// JsFromRoutes CacheKey 8bce6b910ecde38d081ab1b5f5a6ba6f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/setup/topics'),
}
